import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router';
import { UIProvider } from './ui/theme';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // SSE drives freshness; keep refetch-on-focus off so the transcript doesn't
      // flicker, and don't retry auth failures endlessly.
      refetchOnWindowFocus: false,
      staleTime: 5_000,
      retry: 1,
    },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element not found');

createRoot(rootEl).render(
  <StrictMode>
    {/* The Chakra-based design system is the sole UI engine (MUI fully removed). UIProvider
        supplies the theme, color mode and the global CSS reset. */}
    <UIProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </UIProvider>
  </StrictMode>,
);
